export function stringToHash(string) {
  let hash = 0

  if (!string || string.length === 0) return null

  for (let i = 0, char; i < string.length; i++) {
    char = string.charCodeAt(i)
    hash = (hash << 5) - hash + char
    hash = hash & hash
  }

  return hash
}
